import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Icon from 'presentation/icons';
import React from 'react';
import {Loading} from '../Loading/Loading';
import {AlertActionsProps} from './types';

function AlertActions({
	primaryAction,
	primaryText,
	primaryIcon,
	secondaryAction,
	secondaryText,
	secondaryIcon,
	secondaryBtnVariant = 'outlined',
	primaryBtnVariant = 'contained',
	type = 'button',
	flexDirection = 'row',
	form,
	isDisabled,
	isLoading,
	isDisabledSecondary,
	isLoadingSecondary,
	customStackProps,
	dataTagId,
	secondaryBtnDataTagId,
}: AlertActionsProps) {
	return (
		<Stack direction={flexDirection} gap={1} sx={{width: '100%'}} {...customStackProps}>
			{secondaryAction ? (
				<Button
					data-tag-id={secondaryBtnDataTagId}
					disabled={isDisabledSecondary}
					onClick={secondaryAction}
					fullWidth
					variant={secondaryBtnVariant}
					size="large"
					endIcon={
						(isLoadingSecondary ? <Loading size={24} color="inherit" /> : null) ||
						(secondaryIcon ? <Icon name={secondaryIcon} /> : null)
					}>
					{secondaryText}
				</Button>
			) : null}
			<Button
				variant={primaryBtnVariant}
				disabled={isDisabled}
				form={form}
				type={type}
				onClick={type === 'button' ? primaryAction : undefined}
				fullWidth
				size="large"
				endIcon={
					(isLoading ? <Loading size={24} color="inherit" /> : null) ||
					(primaryIcon ? <Icon name={primaryIcon} /> : null)
				}
				data-tag-id={dataTagId}>
				{primaryText}
			</Button>
		</Stack>
	);
}

export {AlertActions};
